export const useImpersonating = (): boolean => {
  const isImpersonating = window.localStorage.getItem('impersonating') === 'true';

  return isImpersonating;
};
